import { ProtobufHttpClient, TokenHandlingHttpClient } from "@ftdr/http-utils";
import { useMemo } from "react";
import { PaymentContextValue } from "../../payment-context";
import { PaymentMethodCoordinatorJSClient } from "../clients";

type UseHandleClients = {
  paymentMethodCoordinatorClient: PaymentMethodCoordinatorJSClient;
};

export type UseHandleClientsProps = Pick<
  PaymentContextValue,
  "token" | "baseURL" | "hostJsClient"
>;

export const useHandleClients = ({
  token,
  baseURL,
  hostJsClient,
}: UseHandleClientsProps): UseHandleClients => {
  const tokenHandlingHttpClient = useMemo(() => {
    return new TokenHandlingHttpClient(token || "");
  }, [token]);

  const protobufHttpClientWithTraceId = useMemo(() => {
    return new ProtobufHttpClient(tokenHandlingHttpClient);
  }, [tokenHandlingHttpClient]);

  const paymentMethodCoordinatorClient = useMemo(() => {
    if (hostJsClient) {
      return hostJsClient as PaymentMethodCoordinatorJSClient;
    }

    return new PaymentMethodCoordinatorJSClient(
      baseURL || "",
      protobufHttpClientWithTraceId
    );
  }, [baseURL, protobufHttpClientWithTraceId, hostJsClient]);

  return { paymentMethodCoordinatorClient };
};
